import { Roles } from '@src/context/AuthorizationContext/types';

export interface AgentConfinsBase {
  address: string;
  bank_account_name: string;
  bank_account_no: string;
  bank_branch: string;
  bank_id: string;
  birth_place: string | null;
  city: string;
  company_id: string;
  company_name: string;
  corporate_email: string;
  district: string;
  dt_birthday: string | null;
  dt_join: string;
  dtm_upd: string;
  emmp_status: boolean;
  emp_name: string;
  emp_no: string;
  id_number: string;
  id_type: string;
  is_internal_marketing_employee: boolean;
  job_title_code: string;
  job_title_name: string;
  marketing_id: string;
  marital_status_id: string | null;
  mobile_phone_no: string;
  nik_marketing: string;
  office_location_area_id: string;
  office_location_region_id: string;
  pos_id: string;
  position_code: string;
  profile_ba: string;
  rt: string;
  rw: string;
  sub_branch_id: string;
  sub_district: string;
  superior_emp_name: string;
  superior_emp_no: string;
  superior_marketing_id: string;
  tax_number: string;
  work_location_code: string;
  work_location_name: string;
  zip_code: string;
  selfie_url: string | null;
  company: string;
  occupation: string;
  industry: string;
  work_position: string;
}

export enum ProductId {
  '4W' = '1',
  '2W' = '2',
  'PBF' = '3',
  'None' = '',
}

export enum RolesWithProduct {
  'HO-APPROVER' = Roles.HoApprover,
  'HO-EDITOR' = Roles.HoEditor,
  'HO-VIEWER' = Roles.HoViewer,
  'AM' = Roles.Am,
  'ABPM' = Roles.Abpm,
  'BM' = Roles.Bm,
  'SPV.4W' = `${Roles.Spv}.${ProductId['4W']}`,
  'SPV.2W' = `${Roles.Spv}.${ProductId['2W']}`,
  'SPV.PBF' = `${Roles.Spv}.${ProductId['PBF']}`,
  'None' = '',
}

export const ROLE_NAME_BY_ROLES_WITH_PRODUCT_ENUM: Record<
  RolesWithProduct,
  string
> = {
  [RolesWithProduct['HO-APPROVER']]: 'HO-APPROVER',
  [RolesWithProduct['HO-EDITOR']]: 'HO-EDITOR',
  [RolesWithProduct['HO-VIEWER']]: 'HO-VIEWER',
  [RolesWithProduct.AM]: 'AM',
  [RolesWithProduct.ABPM]: 'ABPM',
  [RolesWithProduct.BM]: 'BM',
  [RolesWithProduct['SPV.4W']]: 'SPV.4W',
  [RolesWithProduct['SPV.2W']]: 'SPV.2W',
  [RolesWithProduct['SPV.PBF']]: 'SPV.PBF',
  [RolesWithProduct.None]: 'None',
};

export interface GetResponse<T> {
  status: string;
  message: string;
  data: T;
}

export interface ErrorResponse {
  status: string;
  error: string;
  source: string;
  code: string;
  message: string;
  path: string;
  timestamp: number;
}
